import authNetworkService from '../auth-network/auth-network.service';
import correspondenceUrls from './correspondence.urls';

const optInWhatsApp = (phoneNumber: string): Promise<void> => {
  const url = `${correspondenceUrls.optInWhatsApp()}?PhoneNumber=${phoneNumber}`;
  return authNetworkService.post(url);
};

const optOutWhatsApp = (phoneNumber: string): Promise<void> => {
  const url = `${correspondenceUrls.optOutWhatsApp()}?PhoneNumber=${phoneNumber}`;
  return authNetworkService.post(url);
};

const optOutEmail = (email: string, hash: string): Promise<void> => {
  return authNetworkService.post(
    correspondenceUrls.optOutEmail(),
    {
      email,
      hash,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
};

export default {
  optInWhatsApp,
  optOutWhatsApp,
  optOutEmail,
};
